import { render, staticRenderFns } from "./EmailPanelHandler.vue?vue&type=template&id=37d41234&"
import script from "./EmailPanelHandler.vue?vue&type=script&lang=js&"
export * from "./EmailPanelHandler.vue?vue&type=script&lang=js&"
import style0 from "./EmailPanelHandler.vue?vue&type=style&index=0&id=37d41234&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports